import Col from '@visa/vds/col';
import Divider from '@visa/vds/divider';
import Icon from '@visa/vds/icon';
import Radio from '@visa/vds/radio';
import RadioErrorMessage from '@visa/vds/radio-error-message';
import RadioGroup from '@visa/vds/radio-group';
import Row from '@visa/vds/row';
import Typography from '@visa/vds/typography';
import React from 'react';
import '../../Style/Store.css';

const VSTSProductDetails = (props) => {
    return(
        <>
        <Divider type="section" />
        <Row className="store-product-details-row">
            <Col>
                <RadioGroup>
                    <Radio
                        id="VSTS_BaseSubscriptionRadioBtn"
                        disabled={!props.requireBaseSubscription}
                        checked={props.selectedProductInfo === props.BASE_SUBSCRIPTION}
                        label="Base Subscription: 90 calendar day access"
                        name="radio-group-subscription-select"
                        onChange={() => props.handleProductInfoSelected(props.BASE_SUBSCRIPTION)}
                        value={props.BASE_SUBSCRIPTION}
                    />

                    <Typography className="select-product-caption" variant='body'>Includes 90 calendar day access to VSTS, VSTS-specific connection certificates, VSTS test document, Compliance Letter and listing of the product on Visa’s EMV 3DS Approved Products List on successful
                    completion of VSTS testing.</Typography>

                    <Radio
                        id="VSTS_ExtensionSubscriptionRadioBtn"
                        disabled={props.requireBaseSubscription}
                        checked={props.selectedProductInfo === props.EXTENSION_SUBSCRIPTION}
                        label="Extension Subscription: +30 calendar day access"
                        name="radio-group-subscription-select"
                        onChange={() => props.handleProductInfoSelected(props.EXTENSION_SUBSCRIPTION)}
                        value={props.EXTENSION_SUBSCRIPTION}
                    />

                    <Typography className={!props.requireBaseSubscription ? "select-product-caption" : "select-product-caption-disabled"}  variant='body'>Adds an additional 30 calendar day access to VSTS.</Typography>

                    <RadioErrorMessage id="single-validation-error-message">
                        {
                            props.showVSTSProductInfoErrorMessage === true
                                ? <><Icon name="error" resolution="tiny" />Please select an Subscription before proceeding.</>
                                : ''
                        }
                    </RadioErrorMessage>
                </RadioGroup>
            </Col>
        </Row>

        <Divider type="section" />
        </>
    );
}

export default VSTSProductDetails